<template>

  <SubHeading :home="home" :tabs="tabs" :currTab="currTab" @active="handleActive" />

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
          <span>Claims Home</span>
        </span>
        <span class="sba-collection-context">Claims Vetting Workspace</span>
      </div>
    </div>
  </nav>

  <!-- Top -->
  <div id="top"></div>

  <div class="container claim-page-shell">
    <div class="claim-workbench sba-slide-in">
      <div class="claim-review-head">
        <div class="claim-title-row">
          <div class="claim-title-block">
            <label class="active teal-text">Claims Desk</label>
            <h5>Claims Clusters</h5>
            <p>Search, vet, and open provider claim batches moving through the claims workflow.</p>
          </div>
          <div class="claim-title-actions">
            <button type="button" class="claim-search-toggle" @click="toggleSearchFilters">
              <span>{{ showSearchFilters ? "Hide Search" : "Show Search" }}</span>
              <i class="material-icons">{{ showSearchFilters ? "expand_less" : "tune" }}</i>
            </button>
          </div>
        </div>
      </div>

      <div class="claim-filter-shell" v-show="showSearchFilters">
        <div class="claim-filter-card">
          <FilterClaim @search="handleSearch" />
        </div>
      </div>

      <div class="claim-search-summary">
        <span class="summary-label">Current view</span>
        <div class="summary-content" v-if="searchTitle" v-html="searchTitle"></div>
        <div class="summary-content" v-else>
          <span class="summary-chip">All claims clusters</span>
        </div>
      </div>

    <!-- <div class="row">
      <div class="col s12"> -->

        <!-- Vetting Marker -->
        <div id="vet"></div>

        <!-- Claims -->
        <LoadingDiv v-if="!isReady" />

        <div v-else>
          <div class="section" v-if="clusters.length || isLoading">
            <div class="card z-depth-0 grey lighten-4">
            <div class="card-panel z-depth-0 grey lighten-5 z-depth-1">
              <div class="row">
                <div class="col s1 hide-on-small-only">#</div>
                <div class="col s5 m3">Provider <small>(claims)</small></div>
                <div class="col s2 m2">Sent</div>
                <div class="col s3 m2">Approved</div>
                <div class="col s2 hide-on-small-only">Claims <small>(scheme)</small></div>
                <div class="col s2 m1">Status</div>
                <div class="col s1 hide-on-small-only"><br /></div>
              </div>
            </div>

            <div class="progress" v-if="isLoading">
              <div class="indeterminate"></div>
            </div>

            
              <div class="card-panel grey lighten-5" :class="{
                'blue-grey lighten-5': (index + 1) % 2 === 1,
              }" v-for="(cluster, index) in clusters" :key="cluster.id">
                <div class="row">
                  <div class="col s12 m1 hide-on-small-only">
                    <p>{{ numberBadge(index) }}</p>
                  </div>
                  <div class="col s12 m3">
                    <h6>
                      <span v-if="
                        flagCount(cluster, 'supervisor') > 0
                      "><i class="tiny material-icons red-text pointer" title="supervisor issue">flag</i></span>
                      <span v-if="
                        flagCount(cluster, 'hod') > 0
                      "><i class="tiny material-icons red-text pointer" title="hod issue">flag</i></span>
                      <span v-if="
                        flagCount(cluster, 'compliance') > 0
                      "><i class="tiny material-icons red-text pointer" title="compliance issue">flag</i></span>
                      {{ capWords(cluster.provider.name) }}
                    </h6>
                    <p class="claim-count-text" v-if="cluster.status !== 'q'">
                      {{ cluster.encounters_count }} {{ cluster.encounters_count === 1 ? "claim" : "claims" }}
                    </p>
                    <div class="claim-related-badges" v-if="relatedBadges(cluster).length">
                      <span
                        v-for="badge in relatedBadges(cluster)"
                        :key="badge.key"
                        class="claim-related-badge"
                        :class="`is-${badge.key}`"
                      >
                        {{ badge.label }}
                      </span>
                    </div>
                  </div>
                  <div class="col s5 m2">
                    <p>
                      <span class="chip red lighten-5 red-text" v-if="cluster.status === 'q'">₦0.00</span>
                      <span class="chip red lighten-5 red-text" v-else>₦{{ new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cluster.encounters_total_sent || '0.00') }}</span>
                    </p>
                  </div>
                  <div class="col s7 m2">
                    <p>
                      <span class="chip" v-if="cluster.status === 'p'">N/A</span>
                      <span class="chip yellow" v-if="cluster.status === 'q'">N/A</span>
                      <span class="chip green lighten-5 green-text" v-if="cluster.status === 'r' || cluster.status === 'v'"><b>₦{{
                        new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cluster.encounters_total_approved || '0.00') }}</b></span>
                    </p>
                  </div>
                  <div class="col s5 m2">
                    <p>
                      {{ toMonthYear(cluster.month_year) }}
                      <small><b>({{ cluster.scheme.name }})</b></small>
                    </p>
                  </div>
                  <div class="col s4 m1">
                    <p>
                      <span class="chip" :class="{
                        'chip teal lighten-4': paymentStatus(cluster)?.toLowerCase() === 'paid',
                        'chip grey lighten-2': paymentStatus(cluster)?.toLowerCase() === 'pending',
                        'chip orange lighten-2': paymentStatus(cluster)?.toLowerCase() === 'unsubmitted',
                        'chip indigo lighten-4': paymentStatus(cluster)?.toLowerCase() !== 'paid' && paymentStatus(cluster)?.toLowerCase() !== 'pending' && paymentStatus(cluster)?.toLowerCase() !== 'unsubmitted',
                      }">
                        {{
                          paymentStatus(cluster)
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="col s3 m1">
                    <p>
                    <span v-if="cluster.status === 'q'">
                      <span class="btn-floating black pointable right"><i class="material-icons"
                          title="locked">lock_outline</i></span>
                    </span>

                    <span v-if="cluster.status === 'p'">
                      <a class="btn-floating red right"><i class="material-icons" title="review"
                          @click="handleEdit(cluster)">chevron_right</i></a>
                    </span>

                    <span v-if="cluster.status === 'r' || cluster.status === 'v'">
                      <a class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2 right"><i
                          class="material-icons" @click="handleEdit(cluster)" title="details">chevron_right</i></a>
                    </span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- <br /> -->
              
            </div>
          </div>

          <div class="section claim-empty-state" v-if="!clusters.length && !isLoading">
            <div class="claim-empty-icon">
              <i class="material-icons">fact_check</i>
            </div>
            <div class="claim-empty-copy">
              <h6>No claims found</h6>
              <p>There are no claim clusters matching the current claims view.</p>
              <span>Try another scheme, period, or status filter.</span>
            </div>
          </div>

          <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </div>
      <!-- </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import useModuleNavigation from "@/composables/useModuleNavigation";
import getItems from "@/composables/getItems";
import postItem from "@/composables/postItem";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import FilterClaim from "@/components/claim/FilterClaimComponent.vue";
import {
  capWordsFx,
} from "@/composables/fxLibrary/coreFx.js";
import {
  // grossTotalSentFx,
  // grossTotalApprovedFx,
  checkPaidFx,
  paymentStatusFx,
} from "@/composables/calFunction/cal";
import { getCache, addCache } from "@/composables/cache/cache";

export default {
  name: "claimHome",
  components: { SubHeading, LoadingDiv, PaginationDiv, FilterClaim },
  setup() {
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(false);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const searchTitle = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);
    const UIUpdate = ref(true);
    const showSearchFilters = ref(false);
    const currentListUrl = ref(null);
    const pendingSyncRefresh = ref(false);

    // vue router
    const router = useRouter();
    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "All Claims Cluster";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Claims", title: "All", icon: null, url: "claim", hash: null, });
      tabs.value.push({ id: 2, name: "Claims", title: "Vet", icon: "edit", url: "claim", hash: "#vet" });
      tabs.value.push({ id: 3, name: "Claims", title: "Add Claims", icon: "add_circle", url: "claimAdd", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.id === 1);
      // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // starter
    onMounted(() => {
      // get claims from oneProvider
      (async () => {
        const { res } = await postItem("integration/oneprovider/claims/sync", { force: true });

        if (res.value) {
          if (Number(res.value.data?.imported || 0) > 0 && UIUpdate.value) {
            // reload page
            reloadCurrentClaims();
          }
        }
  
      })();
    });

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: tab?.url === "claim" && !tab?.hash });
    };

    const toggleSearchFilters = () => {
      showSearchFilters.value = !showSearchFilters.value;
    };

    const hasFlags = (cluster) => {
      return cluster?.encounters?.some((x) => x.supervisor_flag == 'y' || x.hod_flag == 'y' || x.compliance_flag == 'y');
    };

    const flagCount = (cluster, type) => {
      const countKey = `${type}_flags_count`;
      const flagKey = `${type}_flag`;

      if (cluster?.[countKey] !== undefined && cluster?.[countKey] !== null) {
        return Number(cluster[countKey]) || 0;
      }

      if (!Array.isArray(cluster?.encounters)) {
        return 0;
      }

      return cluster.encounters.filter((x) => x?.[flagKey] == 'y').length;
    };

    const statusClass = (cluster) => {
      const status = paymentStatus(cluster)?.toLowerCase();
      if (status === 'paid') return 'is-paid';
      if (status === 'pending') return 'is-pending';
      if (status === 'unsubmitted') return 'is-unsubmitted';
      return 'is-other';
    };

    const relatedBadges = (cluster) => {
      const badges = [];
      const supplementaryCount = Number(cluster?.related_supplementary_count || 0);
      const reconciliationCount = Number(cluster?.related_reconciliation_count || 0);

      if (supplementaryCount > 0) {
        badges.push({
          key: "supplementary",
          label: `Supplementary${supplementaryCount > 1 ? ` (${supplementaryCount})` : ""}`,
        });
      }

      if (reconciliationCount > 0) {
        badges.push({
          key: "reconciliation",
          label: `Reconciliation${reconciliationCount > 1 ? ` (${reconciliationCount})` : ""}`,
        });
      }

      return badges;
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // total calculations (gross sent)
    // const grossTotalSent = (encounters) => {
    //   return grossTotalSentFx(encounters);
    // };

    // total calculations (gross approved)
    // const grossTotalApproved = (encounters, db) => {
    //   return grossTotalApprovedFx(encounters, db);
    // };

    // convert to Month & Year
    const toMonthYear = (val) => {
      let parts = val.split("_");
      let month = parseInt(parts[0]);
      let year = parseInt(parts[1]);
      let date = new Date(year, month - 1); // months are zero-indexed in JavaScript
      let monthName = date.toLocaleString("default", { month: "short" });
      return monthName + " " + year;
    };

    // payment status
    const checkPaid = (payment, repayment) => {
      return checkPaidFx(payment, repayment);
    };

    // payment status
    const paymentStatus = (cluster) => {
      return paymentStatusFx(cluster);
    };

    // get function
    const getItemsFromApi = (table, options = {}) => {
      if (!table) {
        return;
      }

      currentListUrl.value = table;

      // get item from store (cache)
      let cache = getCache(table);
      // load cache
      if (cache && !options.skipCache) {
        response.value = cache;
        isReady.value = true;
      }
      // get current from server
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
          // add cache
          addCache(table, response.value);
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // handle search (emitted from component)
    const handleSearch = (val) => {
      // start loading
      isLoading.value = true;
      // set current Url
      currUrl.value = val.currUrl;
      // set current Hook
      currHook.value = val.currHook;
      // set search title
      searchTitle.value = val.searchTitle;
      const skipCache = pendingSyncRefresh.value;
      // claim sync may finish before the default filter initializes
      pendingSyncRefresh.value = false;
      // get items from function
      getItemsFromApi(currUrl.value, { skipCache });
    };

    const reloadCurrentClaims = () => {
      const targetUrl = currentListUrl.value || currUrl.value;

      if (!targetUrl) {
        pendingSyncRefresh.value = true;
        return;
      }

      pendingSyncRefresh.value = false;
      isLoading.value = true;
      getItemsFromApi(targetUrl, { skipCache: true });
    };

    // handle edit
    const handleEdit = (cluster) => {
      router.push({ name: "claimView", params: { clusterId: cluster.id } });
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isLoading.value = true;
      // go back up
      router.push({ hash: "#top" });
      // get new page items from function
      getItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`);
      // kill update
      UIUpdate.value = false;
    };

    // output results
    const clusters = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data; // get data portion
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      handleActive,
      toggleSearchFilters,
      hasFlags,
      flagCount,
      statusClass,
      relatedBadges,
      home,
      currTab,
      tabs,
      showSearchFilters,
      capWords,
      numberBadge,
      // grossTotalSent,
      // grossTotalApproved,
      toMonthYear,
      checkPaid,
      paymentStatus,
      handlePage,
      handleSearch,
      handleEdit,
      isReady,
      isLoading,
      error,
      searchTitle,
      clusters,
      allPages,
    };
  },
};
</script>

<style scoped>
.claim-page-shell {
  margin-top: -14px;
  padding-top: 0;
  padding-bottom: 44px;
  position: relative;
  z-index: 1;
}

.claim-workbench {
  color: #263238;
}

.claim-review-head,
.claim-filter-shell,
.claim-search-summary,
.claim-workbench .section > .card,
.claim-workbench .section > .card > .card-panel:first-child,
.claim-workbench .section > .card > .card-panel.grey.lighten-5,
.claim-workbench .section > .card > .progress,
.claim-empty-state {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.claim-review-head,
.claim-filter-shell,
.claim-search-summary {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none;
  width: 100%;
}

.claim-review-head {
  align-items: flex-end;
  border-color: #c4d3d9;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  margin-bottom: 0;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.claim-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.claim-title-row {
  align-items: flex-end;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  position: relative;
  width: 100%;
  z-index: 2;
}

.claim-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.claim-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 780px;
}

.claim-title-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
}

.claim-search-toggle {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 999px;
  color: #263238;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 13px 0 16px;
}

.claim-search-toggle i {
  color: #00897b;
  font-size: 19px;
}

.claim-filter-shell {
  border-color: #c4d3d9;
  border-radius: 0;
  border-top: 0;
  box-shadow: 0 14px 24px -24px rgba(38, 50, 56, 0.68);
  padding: 18px 24px 22px;
}

.claim-filter-card {
  background: #ffffff;
  border: 1px solid #c7d3d8;
  border-radius: 6px;
  box-shadow: none;
  overflow: visible;
  padding: 10px;
  width: 100%;
}

.claim-filter-card :deep(.sectionx > br) {
  display: none;
}

.claim-filter-card :deep(form),
.claim-filter-card :deep(.row) {
  margin: 0;
}

.claim-filter-card :deep(.row) {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
}

.claim-filter-card :deep(.col) {
  border: 1px solid #c7d3d8;
  border-radius: 6px;
  min-width: 0;
  padding: 0 !important;
  width: 100% !important;
}

.claim-filter-card :deep(nav) {
  background: transparent !important;
  box-shadow: none !important;
  height: auto;
  line-height: normal;
  min-height: 52px;
}

.claim-filter-card :deep(.input-field) {
  height: auto;
  margin-bottom: 0;
  margin-top: 0;
  min-height: 52px;
}

.claim-filter-card :deep(.nav-wrapper) {
  background: transparent;
  height: auto;
  line-height: normal;
  min-height: 52px;
}

.claim-filter-card :deep(input),
.claim-filter-card :deep(.select-wrapper input.select-dropdown) {
  background: transparent;
  border: none !important;
  box-sizing: border-box;
  color: #263238 !important;
  font-size: 1.02rem;
  font-weight: 700;
  height: 52px !important;
  line-height: 52px;
  margin: 0;
  padding: 0 42px 0 16px !important;
  width: 100%;
}

.claim-filter-card :deep(input:focus) {
  box-shadow: inset 0 -2px 0 #00897b !important;
}

.claim-filter-card :deep(.material-icons) {
  color: #00897b !important;
  height: 52px;
  line-height: 52px;
  right: 10px;
  top: 0;
}

.claim-filter-card :deep(.dropdown-content) {
  border-top: 1px solid #dfe7ea;
  box-shadow: none;
  margin: 0;
  max-height: 190px;
  overflow-y: auto;
  position: static !important;
  transform: none !important;
  width: 100% !important;
  z-index: 1;
}

.claim-filter-card :deep(.dropdown-content li > span) {
  color: #00897b;
  line-height: 1.35;
  padding: 12px 20px;
}

.claim-search-summary {
  align-items: center;
  background: #f7f7f7;
  border-color: #c4d3d9;
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0 12px 22px -24px rgba(38, 50, 56, 0.68);
  display: flex;
  gap: 14px;
  justify-content: space-between;
  padding: 14px 24px;
}

.summary-label {
  color: #607d8b;
  flex: 0 0 auto;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
}

.summary-content {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
  min-width: 0;
  text-align: right;
}

.claim-search-summary :deep(.chip),
.summary-chip {
  background: #ffffff !important;
  border: 1px solid #e7c967;
  border-radius: 999px;
  color: #263238 !important;
  font-size: 0.82rem;
  font-weight: 700;
  height: auto;
  line-height: 1.2;
  margin: 0 6px 6px 0;
  padding: 7px 12px;
}

.claim-search-summary :deep(.chip:first-child),
.summary-chip {
  border-color: #80cbc4;
}

.claim-workbench .section {
  margin: 0;
  padding: 0;
}

.claim-workbench .section > .card {
  background: #ffffff !important;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  margin: 16px 0 0;
  overflow: hidden;
  padding: 14px;
}

.claim-workbench .section > .card > .card-panel:first-child {
  background: #f5f7f8 !important;
  border: 0;
  border-bottom: 1px solid #e3e8eb;
  border-radius: 6px;
  box-shadow: none !important;
  color: #607d8b;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 12px;
  padding: 13px 20px;
  text-transform: uppercase;
}

.claim-workbench .section > .card > .card-panel.grey.lighten-5 {
  background: linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%) !important;
  border: 1px solid #dfe7ea;
  border-radius: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  margin-bottom: 12px;
  padding: 24px 22px;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.claim-workbench .section > .card > .card-panel.grey.lighten-5:hover {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbfc 100%) !important;
  border-color: #b7cbd2;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 20px 36px -28px rgba(38, 50, 56, 0.82);
  transform: translateY(-1px);
}

.claim-workbench .section > .card > .progress {
  background: #e7ecef;
  border-radius: 0;
  height: 4px;
  margin: -12px 0 12px;
  overflow: hidden;
}

.claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
}

.claim-workbench h6 {
  color: #263238;
  font-size: 1.06rem;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.claim-count-text {
  color: #607d8b !important;
  font-size: 0.84rem;
  font-weight: 400 !important;
  line-height: 1.35;
  margin-top: 4px !important;
}

.claim-related-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.claim-related-badge {
  border: 1px solid #d5e2e7;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1;
  padding: 5px 8px;
  text-transform: uppercase;
}

.claim-related-badge.is-supplementary {
  background: #e8f5e9;
  border-color: #a5d6a7;
  color: #2e7d32;
}

.claim-related-badge.is-reconciliation {
  background: #e3f2fd;
  border-color: #90caf9;
  color: #1565c0;
}

.claim-workbench p {
  color: #263238;
  font-weight: 600;
  margin: 0;
}

.claim-workbench .chip {
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  margin: 0;
}

.claim-workbench .btn-floating {
  box-shadow: none;
}

.claim-workbench .btn-floating i {
  font-size: 20px;
}

.claim-workbench .claim-empty-state {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: 0 18px 34px -31px rgba(38, 50, 56, 0.75);
  color: #607d8b;
  display: flex;
  gap: 16px;
  margin-top: 16px;
  min-height: 150px;
  padding: 28px 30px;
  text-align: left;
}

.claim-empty-icon {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #cde8e5;
  border-radius: 6px;
  color: #00897b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 52px;
  justify-content: center;
  width: 52px;
}

.claim-empty-icon i {
  font-size: 27px;
}

.claim-empty-copy h6 {
  color: #263238;
  font-size: 1.02rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.claim-empty-copy p {
  color: #607d8b;
  font-size: 0.94rem;
  line-height: 1.45;
  margin: 7px 0 0;
}

.claim-empty-copy span {
  color: #78909c;
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  margin-top: 9px;
}

.claim-workbench :deep(.pagination) {
  margin-top: 28px;
}

.progress {
  margin-top: -15px;
}

.clickable {
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.clickable:hover {
  opacity: 0.8;
}

.pointable {
  cursor: default;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.pointable:hover {
  opacity: 0.8;
}

.spacer {
  padding: 2px;
}

.pointer {
  cursor: default;
}

/* base class */
.tab-custom {
  color: #747373;
  border: 1px solid white;
  background-color: white;
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  border-bottom: 2px solid white;
}

.tab-custom:hover {
  color: #000000 !important;
}

/* Removed (re-added)
  color: #000000;
  border: 1px solid #ddd;
  background-color: #d1f3df; */
.tab-custom-active {
  color: #000000;
  border: 1px solid #ddd;
  background-color: #d1f3df;
  display: inline-block;
  cursor: pointer;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  border-bottom: 2px solid orange;
}

/* display */
.tab-custom-section {
  padding: 20px 0 0;
  border-top: 1px solid #ddd;
}

@media only screen and (max-width: 992px) {
  .claim-title-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .claim-page-shell {
    margin-top: -12px;
  }

  .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
    gap: 12px 0;
  }
}

@media only screen and (max-width: 600px) {
  .claim-review-head {
    padding: 22px;
  }

  .claim-title-block h5 {
    font-size: 1.45rem;
  }

  .claim-title-block p {
    font-size: 0.94rem;
  }

  .claim-search-toggle {
    justify-content: space-between;
    width: 100%;
  }

  .claim-title-actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .claim-filter-card {
    padding: 10px;
  }

  .claim-filter-card :deep(.col) {
    width: 100% !important;
  }

  .claim-search-summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 12px 16px;
  }

  .summary-content {
    justify-content: flex-start;
    text-align: left;
  }

  .claim-workbench .section > .card {
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    margin-left: -12px;
    margin-right: -12px;
    padding: 10px;
  }

  .claim-workbench .section > .card > .card-panel:first-child {
    display: none;
  }

  .claim-workbench .section > .card > .card-panel.grey.lighten-5 {
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 16px;
  }

  .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
    align-items: stretch;
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr 1fr;
  }

  .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col {
    margin-left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100% !important;
  }

  .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col:nth-child(2),
  .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col:last-child {
    grid-column: 1 / -1;
  }

  .claim-workbench h6 {
    font-size: 1rem;
  }

  .claim-workbench p {
    font-size: 0.86rem;
  }

  .claim-workbench .chip {
    height: auto;
    line-height: 1.25;
    min-height: 30px;
    padding: 7px 10px;
    white-space: normal;
  }

  .claim-workbench .btn-floating {
    align-items: center;
    border-radius: 8px;
    display: inline-flex;
    float: none !important;
    height: 40px;
    justify-content: center;
    width: 100%;
  }

  .claim-workbench .claim-empty-state {
    align-items: flex-start;
    flex-direction: column;
    padding: 22px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .claim-review-head,
  .claim-filter-shell,
  .claim-search-summary,
  .claim-workbench .section > .card,
  .claim-workbench .section > .card > .card-panel:first-child,
  .claim-workbench .section > .card > .card-panel.grey.lighten-5,
  .claim-workbench .section > .card > .progress,
  .claim-empty-state {
    animation: none;
  }
}
</style>
